import React, { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import DesktopView from "./desktop-view/desktopView";
import MobileView from "./mobile-view/mobileView";

const Price = ({ node }) => {
  const [productQuantity, setProductQuantity] = useState(1);

  const handleQuantityIncrement = () => {
    setProductQuantity(productQuantity + 1);
  };

  const handleQuantityDecrement = () => {
    if (productQuantity > 1) {
      setProductQuantity(productQuantity - 1);
    }
  };

  return (
    <Box>
      <Box sx={{ display: { xs: "none", sm: "block", md: "block" } }}>
        <DesktopView
          node={node}
          quantityIncreaseHandler={handleQuantityIncrement}
          quantityDecreaseeHandler={handleQuantityDecrement}
          productQuantity={productQuantity}
        />
      </Box>
      <Box sx={{ display: { xs: "block", sm: "none", md: "none" } }}>
        <MobileView
          node={node}
          quantityIncreaseHandler={handleQuantityIncrement}
          quantityDecreaseeHandler={handleQuantityDecrement}
          productQuantity={productQuantity}
        />
      </Box>
    </Box>
  );
};

export default Price;
